import { Link, useOutletContext } from "react-router-dom";
import { Home, RefreshCw, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

function ServerError() {
  const context = useOutletContext();
  const isDark = context?.isDark ?? true;

  return (
    <div className="min-h-screen flex items-center justify-center py-12">
      <div className="max-w-lg mx-auto px-4 text-center">
        {/* 500 Number */}
        <h1 className={`text-[8rem] md:text-[10rem] font-black font-['Chivo'] leading-none ${isDark ? 'text-white/10' : 'text-slate-200'}`}>
          500
        </h1>

        {/* Message */}
        <div className="-mt-10 relative z-10">
          <h2 className={`text-2xl md:text-3xl font-bold font-['Chivo'] mb-4 ${isDark ? 'text-white' : 'text-slate-900'}`}>
            Er ging iets mis
          </h2>
          <p className={`mb-8 ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
            Er is een onverwachte fout opgetreden op de server. Probeer de pagina opnieuw te laden of kom later terug.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={() => window.location.reload()} 
              className="bg-[hsl(48,96%,53%)] hover:bg-[hsl(48,96%,43%)] text-black font-semibold"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Pagina herladen
            </Button>
            <Button asChild variant="outline" className={isDark ? 'border-white/20 text-white hover:bg-white/10' : ''}>
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                Naar homepagina
              </Link>
            </Button>
          </div>
        </div>

        {/* Decorative Element */}
        <div className="mt-12 flex justify-center">
          <AlertTriangle className={`h-16 w-16 ${isDark ? 'text-white/5' : 'text-slate-100'}`} />
        </div>
      </div>
    </div>
  );
}

export default ServerError;
